import type { Editor } from 'hugerte';

import type { TranslationKey } from '@change-corgi/core/i18n';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { getIframeCount, getImageCount } from '#src/app/shared/utils/richMedia';

import { MAX_IMAGE_COUNT, MAX_IMAGE_ERROR_TEXT, MAX_VIDEO_COUNT, MAX_VIDEO_ERROR_TEXT } from '../constants';

export const setupCustomToolbar = (
	utilityContext: UtilityContext,
	{
		editor,
		setErrorKey,
	}: {
		editor: Editor;
		setErrorKey: (errorKey: TranslationKey | null) => void;
	},
): void => {
	editor.ui.registry.addButton('customImageToolbar', {
		icon: 'image',
		tooltip: utilityContext.i18n.translate('corgi.components.rich_media.buttons.add_image'),
		onAction: () => {
			if (getImageCount(editor.getContent()) >= MAX_IMAGE_COUNT) {
				setErrorKey(MAX_IMAGE_ERROR_TEXT);
			} else {
				setErrorKey(null);
				editor.execCommand('mceImage');
			}
		},
	});
	editor.ui.registry.addButton('customMediaToolbar', {
		icon: 'embed',
		tooltip: utilityContext.i18n.translate('corgi.components.rich_media.buttons.add_video'),
		onAction: () => {
			if (getIframeCount(editor.getContent()) >= MAX_VIDEO_COUNT) {
				setErrorKey(MAX_VIDEO_ERROR_TEXT);
			} else {
				setErrorKey(null);
				editor.execCommand('mceMedia');
			}
		},
	});
};
